import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Formik, Form, Field} from 'formik';
import { useDispatch , useSelector } from 'react-redux';
// import './PostChatSurvey.scss'
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import { setPage } from '../../redux/actions/commonActions';
import * as Yup from 'yup';

const PostChatSurveyWrapper = styled.div`
    height: 100%;
    padding: 10px;
`;

const InvalidFeedback = styled.span`
    color: #dc3545;
    font-size: 12px;
    margin-top: 10px;
    font-family: 'Nunito', sans-serif;
`

const Console = prop => (
console[Object.keys(prop)[0]](...Object.values(prop))
,null // ➜ React components must return something 
)

export const PostChatSurvey = () => {

//@ts-ignore
const {user , ui , engagement, page } = useSelector(state=>state);
const navigate = useNavigate();
const formikRef = useRef();
const firstNameRef = useRef();
//@ts-ignore
const dispatch = useDispatch()
const config = ui?.config?.attributes;
const appAvayaSurvey = config?.AvayaSurvey

const PostSurveySchema = Yup.object().shape({
    resolved:Yup.string().required(appAvayaSurvey?.requiredLabel).trim().label('Resolved'),
    satisfaction:Yup.string().required(appAvayaSurvey?.requiredLabel).trim().label('Satisfaction'),
    // areasToReview:Yup.string().required(appAvayaSurvey?.requiredLabel).trim().label('Areas To Review'),
    // comments:Yup.string().required(appAvayaSurvey?.requiredLabel).trim().label('Areas To Review'),
});

const handleOnEscBtnPressed = ()=>{
    document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    let isInChatComponent = document.activeElement.closest("chat-app")
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } 
    if (isEscape && isInChatComponent ) {
        //@ts-ignore
        formikRef?.current?.resetForm()
    }
};  
}


useEffect(()=>{
    handleOnEscBtnPressed()
    dispatch(setPage('post-chat-survey'));
    document.body.style.overflow = "auto";
},[])

const clickBack = event => {
    // navigate('/chat')
    dispatch(setPage('chat'))
    document.body.style.overflow = "hidden";
}


return  (
<>
    <PostChatSurveyWrapper>
        <div className="avaya-survey-widget ng-scope" ng-controller="avayaSurveyController">
            <div className="avaya-survey-content-wrapper">
                <div className="avaya-survey-content-container">
                    <header className="text-center">
                        <h2>{ appAvayaSurvey?.header }</h2>
                        <h3>{ appAvayaSurvey?.subheader }</h3>
                    </header>
                    <div className="avaya-survey-content">
                        <h4 className="ng-binding">{ appAvayaSurvey?.questionHeader }</h4>
                        <Formik
                        innerRef={formikRef}
                        initialValues={{
                            resolved: '',
                            satisfaction:'',
                            areasToReview: '',
                            comments: ''
                        }}
                        validationSchema={PostSurveySchema}
                        onSubmit={values => {
                            let postSurveyData = {
                                resolved: values.resolved,
                                satisfaction: values.satisfaction,
                                areasToReview: values.areasToReview,
                                comments: values.comments,
                            }
                            console.log(postSurveyData);
                            // dispatch(submitSurvey(postSurveyData));
                            window.close();
                        }}
                        >
                        {({ values , errors, touched , setFieldValue }) => (
                        <Form  placeholder="" className="ng-pristine ng-invalid ng-invalid-required">
                            <div className="resolved-container">
                                <p className="ng-binding">
                                <span className="red">*</span> 
                                { appAvayaSurvey?.question1 }</p>
                                { appAvayaSurvey?.q1Options?.map((q1Option) => {
                                    return (
                                    <div>
                                        <Field className="form-check-input" 
                                            type="radio" 
                                            name="resolved" 
                                            value={ q1Option.value }/>
                                            <span className="ng-binding">{ q1Option.name }</span>
                                    </div>
                                    );
                                })
                                }
                                {errors.resolved && touched.resolved ? (
                                <InvalidFeedback id="firstNameFeedback">{errors.resolved}</InvalidFeedback>
                                ) : null}
                            </div>
                            
                            <div className="satisfaction-container">
                                <p className="ng-binding"><span className="red">*</span> { appAvayaSurvey?.question2 } </p>
                                <ul className="satisfaction-list clearfix">
                                    <li>
                                        <div className="smiley happy">
                                            <div className="eye left"></div>
                                            <div className="eye right"></div>
                                            <div className="mouth"></div>
                                        </div>
                                        <Field className="form-check-input ng-pristine ng-invalid ng-invalid-required" type="radio" name="satisfaction" 
                                        value={ appAvayaSurvey?.q2Option1?.split('|')[1] }/>
                                        <span className="ng-binding">{ appAvayaSurvey?.q2Option1?.split('|')[0] }</span>
                                    </li>
                                    <li>
                                        <div className="smiley normal">
                                            <div className="eye left"></div>
                                            <div className="eye right"></div>
                                            <div className="mouth"></div>
                                        </div>
                                        <Field className="form-check-input ng-pristine ng-invalid ng-invalid-required" type="radio" name="satisfaction" 
                                        value={ appAvayaSurvey?.q2Option2?.split('|')[1] }/>
                                        <span className="ng-binding">{ appAvayaSurvey?.q2Option2?.split('|')[0] }</span>
                                    </li>
                                    <li>
                                        <div className="smiley sad">
                                            <div className="eye left"></div>
                                            <div className="eye right"></div>
                                            <div className="mouth"></div>
                                        </div>
                                        <Field className="form-check-input ng-pristine ng-invalid ng-invalid-required" type="radio" name="satisfaction" 
                                        value={ appAvayaSurvey?.q2Option3?.split('|')[1] }/>
                                        <span className="ng-binding">{ appAvayaSurvey?.q2Option3?.split('|')[0] }</span>
                                    </li>
                                </ul>
                                {errors.satisfaction && touched.satisfaction ? (
                                <InvalidFeedback id="firstNameFeedback">{errors.satisfaction}</InvalidFeedback>
                                ) : null}
                            </div>

                            
                            {
                            (values.satisfaction == appAvayaSurvey?.q2Option3?.split('|')[1]) ? 
                            <div className="areas-to-review-container">
                                <p><span className="red">*</span> { appAvayaSurvey?.question3 }</p>
                                
                                <Field as="select" className="avaya-survey-select"  name="areasToReview">
                                    { appAvayaSurvey?.q3Options.map(q3Option => {
                                        return (
                                                <option 
                                                value={ q3Option.value } >{ q3Option.name }</option>
                                        );
                                        })
                                    }
                                </Field>
                                {errors.areasToReview && touched.areasToReview ? (
                                <InvalidFeedback id="firstNameFeedback">{errors.areasToReview}</InvalidFeedback>
                                ) : null}
                            </div> : null
                            }
                            
                            <div className="textarea-container">
                                <p className="ng-binding">{ appAvayaSurvey?.commentBoxHeader }</p>
                        <textarea className="avaya-survey-textarea ng-pristine ng-valid" rows={4} cols={98} ng-model="formData.comments" name='comments'></textarea>
                            </div>
                        </Form>
                        )}

                    </Formik>

                    <div className="avaya-survey-btn-container text-center t">
                                <button className="avaya-survey-btn" onClick={clickBack}>{ appAvayaSurvey?.backButton }</button>
                                <button className="avaya-survey-btn" type="submit"
                                onClick={
                                    ()=>{
                                    formikRef.current?.submitForm()
                                    }
                                }>
                                    { appAvayaSurvey?.sendButton }</button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </PostChatSurveyWrapper>
</>
)
}

export default PostChatSurvey;